import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ModalEnum } from 'myParkdUtils/enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import * as modalWindowActions from 'root/modal/modalWindowActions';

const NoAppAccountMessage = props => {
    return (
        <div>
            <p className="blue-box">
                <FontAwesomeIcon icon={faExclamationTriangle} className="fa-icon" />
                <FormattedMessage id="NO_APP_ACCOUNT_MESSAGE" />
            </p>

            <hr className="hr" />
            <button className="btn-blue" onClick={() => props.updateModal(ModalEnum.CHOOSE_CONNECTION)}>
                <FormattedMessage id="REQUEST_CONNECTION" />
            </button>
        </div>
    );
};

function mapStateToProps(state, props) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateModal: modalWindowActions.updateModalWindow
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(NoAppAccountMessage);
